import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl } from '@angular/forms';
import { ButtonComponent } from '@app/partials/form/button/button.component';
import { DatePickerComponent } from '@app/partials/form/date-picker/date-picker.component';
import { AlertTriangle, CheckCircle, X } from 'lucide-angular';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-price-locking-warning-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, DatePickerComponent, LucideAngularModule],
  template: `
    <div class="fixed inset-0 z-[1000] overflow-y-auto" *ngIf="isOpen">
      <div class="flex min-h-screen items-center justify-center p-4">
        <div class="fixed inset-0 bg-black/50 transition-opacity" (click)="onCancel()"></div>

        <div class="relative z-10 w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-xl dark:bg-gray-900">
          <div class="flex items-start gap-4 p-6">
            <div class="flex h-11 w-11 items-center justify-center rounded-full bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-300">
              <lucide-icon [name]="AlertTriangleIcon" [size]="22"></lucide-icon>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                Confirm event status
              </h3>
              <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
                Are you sure you want to confirm this event?
              </p>
            </div>
            <button
              class="text-gray-400 transition-colors hover:text-gray-600 dark:hover:text-gray-200"
              (click)="onCancel()"
              aria-label="Close confirmation modal">
              <lucide-icon [name]="XIcon" [size]="18"></lucide-icon>
            </button>
          </div>

          <div class="px-6 pb-2" *ngIf="showConfirmedDate && confirmedDateControl">
            <app-date-picker
              [control]="confirmedDateControl"
              [name]="'confirmed_at'"
              [label]="confirmedDateLabel">
            </app-date-picker>
            <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
              Set the date the booking was confirmed.
            </p>
          </div>

          <div class="flex items-center justify-end gap-3 bg-gray-50 px-6 py-4 dark:bg-gray-800/60">
            <app-button
              [label]="'Cancel'"
              [style]="'secondary'"
              [icon]="XIcon"
              (click)="onCancel()">
            </app-button>
            <app-button
              [label]="'Confirm'"
              [style]="'primary'"
              [icon]="CheckIcon"
              (click)="onConfirm()">
            </app-button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class PriceLockingWarningModalComponent {
  @Input() isOpen = false;
  @Input() showConfirmedDate = false;
  @Input() confirmedDateLabel = 'Confirmed Date';
  @Input() confirmedDateControl?: FormControl;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  protected readonly AlertTriangleIcon = AlertTriangle;
  protected readonly XIcon = X;
  protected readonly CheckIcon = CheckCircle;

  onConfirm() {
    this.confirmed.emit();
  }

  onCancel() {
    this.cancelled.emit();
  }
}
